interface IProcessEnv {
    NODE_ENV: TNodeEnv;
    APP_ENV: string;
    APP_NAME: string;
    APP_LIST: string[];
    APP_CONFIG?: {
        AREA: string;
        THEME: string;
        ADMIN_TYPE: string;
        APP_SOURCE: string;
        SYSTEM_CODE: string;
        REACT_APP_VERSION: string;
        APP_AREA: string;
        API_PREFIX: string;
        WWW_HOST: string;
    };
}

const processEnv: IProcessEnv = process.env as any;

type TNodeEnv = 'development' | 'production';
type TAppEnv =
    | 'dev'
    | 'debug'
    | 'debug2'
    | 'test'
    | 'tes2'
    | 'beta'
    | 'release';

interface IEnv {
    nodeEnv: TNodeEnv;
    appEnv: TAppEnv;
    appName: string;
    appList: string[];
    appConfig: {
        area: string;
        theme: string;
        adminType: string;
        appSource: string;
        systemCode: string;
        reactAppVersion: string;
        appArea: string;
        apiPrefix: string;
        wwwHost: string;
    };
    isDev: boolean;
    isBetaRelease: boolean;
    isDebug: boolean;
    isWebview: boolean;
}

const APP_ENV = String(processEnv.APP_ENV) as TAppEnv;

export const env: IEnv = {
    nodeEnv: String(processEnv.NODE_ENV) as TNodeEnv,
    appEnv: String(processEnv.APP_ENV) as TAppEnv,
    appName: String(processEnv.APP_NAME),
    appList: processEnv.APP_LIST,
    appConfig: {
        area: String(processEnv.APP_CONFIG?.AREA || ''),
        theme: String(processEnv.APP_CONFIG?.THEME || ''),
        adminType: String(processEnv.APP_CONFIG?.ADMIN_TYPE || ''),
        appSource: String(processEnv.APP_CONFIG?.APP_SOURCE || ''),
        systemCode: String(processEnv.APP_CONFIG?.SYSTEM_CODE || ''),
        apiPrefix: String(processEnv.APP_CONFIG?.API_PREFIX || ''),
        appArea: String(processEnv.APP_CONFIG?.APP_AREA || ''),
        reactAppVersion: String(processEnv.APP_CONFIG?.REACT_APP_VERSION || ''),
        wwwHost: String(processEnv.APP_CONFIG?.WWW_HOST || '')
    },
    isDev: Boolean(process.env.NODE_ENV === 'development'),
    isBetaRelease: APP_ENV === 'beta' || APP_ENV === 'release',
    isDebug: APP_ENV === 'debug',
    isWebview:
        ((window as any).webkit &&
            (window as any).webkit?.messageHandlers &&
            (window as any).webkit?.messageHandlers?.javascriptBridge &&
            (window as any).webkit?.messageHandlers?.javascriptBridge
                ?.postMessage) ||
        (window as any).javascriptBridge ||
        false
};
